module.exports = __webpack_public_path__ + "static/media/img1-3.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/limon/nutricheck_foliar/FE/img1-3.png
// module id = 1648
// module chunks = 3